import {
  SET_CARE_ORCH_CAPACITY_TASKS,
  SET_CARE_ORCH_ERROR,
  SET_CARE_ORCH_LAST_FETCHED_AT,
  SET_CARE_ORCH_LOADING,
  SET_CARE_ORCH_META,
  SET_CARE_ORCH_STATS,
  SET_CARE_ORCH_TASK_TITLE_OVERRIDES,
} from './actionTypes';

export const setCareOrchestrationLoading = (isLoading) => ({
  type: SET_CARE_ORCH_LOADING,
  payload: { isLoading },
});

export const setCareOrchestrationError = (error) => ({
  type: SET_CARE_ORCH_ERROR,
  payload: { error },
});

export const setCareOrchestrationStats = (stats) => ({
  type: SET_CARE_ORCH_STATS,
  payload: { stats },
});

export const setCareOrchestrationMeta = (meta) => ({
  type: SET_CARE_ORCH_META,
  payload: { meta },
});

export const setCareOrchestrationLastFetchedAt = (lastFetchedAt) => ({
  type: SET_CARE_ORCH_LAST_FETCHED_AT,
  payload: { lastFetchedAt },
});

export const setCareOrchestrationCapacityTasks = (capacityTasks) => ({
  type: SET_CARE_ORCH_CAPACITY_TASKS,
  payload: { capacityTasks },
});

export const setCareOrchestrationTaskTitleOverrides = (taskTitleOverrides) => ({
  type: SET_CARE_ORCH_TASK_TITLE_OVERRIDES,
  payload: { taskTitleOverrides },
});
